import { Pipe, PipeTransform } from '@angular/core';
import * as HelperFunctions from 'src/assets/helper-functions/helper-functions';
import { DaysOfTheWeek } from 'src/app/store/application';

@Pipe({
  name: 'weekdayNames'
})
export class WeekdayNamesPipe implements PipeTransform {

  transform(weekdayIndexes: number[]): string {
    var weekdayStrings = weekdayIndexes.map(i => {
      let index = i;
      if (i > 7) index -= 7; // if weekday index was provided in 14-day format

      var convertedIndex = HelperFunctions.getDayOfWeekFromNumber(index);
      return DaysOfTheWeek[convertedIndex];
    })
    if (weekdayIndexes.length == 1) {
      return weekdayStrings[0]
    } else if (weekdayIndexes.length == 2) { 
      return weekdayStrings[0] + " and " + weekdayStrings[1]
    } else {
      return weekdayStrings.splice(0, weekdayStrings.length - 1).join(", ") + ", and " + weekdayStrings[weekdayStrings.length - 1]
    }
  }

}
